import { memo } from "react";
import Svg, { Path, type SvgProps } from "react-native-svg";

const SvgAddToCalendar = (props: SvgProps) => (
  <Svg fill="none" height={25} width={24} {...props}>
    <Path
      clipRule="evenodd"
      d="M5.583 1.172a1.031 1.031 0 1 1 2.063 0v.802h6.187v-.802a1.031 1.031 0 0 1 2.063 0v.802h2.52a2.75 2.75 0 0 1 2.75 2.75v9.417h-2.062v-3H3.063v7.25c0 .38.307.687.687.687H14v2.063H3.75A2.75 2.75 0 0 1 1 18.39V4.724a2.75 2.75 0 0 1 2.75-2.75h1.833zm8.25 2.864v2.407a1.031 1.031 0 0 0 2.063 0V4.036h2.52c.38 0 .688.308.688.688v4.583H3.063V4.724c0-.38.307-.688.687-.688h1.833v2.407a1.031 1.031 0 0 0 2.063 0V4.036z"
      fill={props.color}
      fillRule="evenodd"
    />
    <Path d="M21 16.14h-2v3h-3v2h3v3h2v-3h3v-2h-3z" fill={props.color} />
  </Svg>
);
const Memo = memo(SvgAddToCalendar);
export default Memo;
